var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-clouds-container"},[_c('div',{staticClass:"team-clouds"},_vm._l((15),function(x){return _c('div',{key:x,staticClass:"team-cloud"},_vm._l((5),function(y){return _c('div',{key:y,staticClass:"team-cloud-piece"})}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }